export default (str) => {
    if (str?.trim() === '') {
        return true;
    }

    return false;
};
